let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cho3x")).then(() => parcelRequire('kS6aD'));